// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import './polyfills'

// asset imports
import 'bootstrap/scss/bootstrap.scss'
import './styles/now-ui-dashboard.scss'

// library auto imports
import 'es6-promise/auto'
import VueMq from 'vue-mq'
// Notifications plugin. Used on Notifications page
import Notifications from './ui/NotificationPlugin'
// Validation plugin used to validate forms
import VeeValidate from 'vee-validate'
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents'
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives'
// Sidebar menu
import SideBar from './ui/SidebarPlugin'

VeeValidate.Validator.extend('greaterThanZero', {
  getMessage: field => `Value of ${field} must be greater than zero.`,
  validate: value => parseFloat(value) > 0
})

export default {
  install(Vue) {
    Vue.use(SideBar)
    Vue.use(GlobalComponents)
    Vue.use(GlobalDirectives)
    Vue.use(Notifications)
    Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
    Vue.use(VueMq, {
      breakpoints: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1400,
        xxl: Infinity
      }
    })
  }
}
